import * as React from 'react'
import { StyleSheet, View, type ViewStyle } from 'react-native'
import * as Icons from '@purposity/icons'

interface CardBadge {
  wrapperStyle?: ViewStyle
  color: string
  icon: Icons.IconLookup
  alt: string
}

export function CardBadge(props: CardBadge) {
  return (
    <View
      style={[badgeStyles.base, props.wrapperStyle]}
      aria-checked
      aria-label={props.alt}
    >
      <Icons.FontAwesomeIcon icon={props.icon} size={18} color={props.color} />
    </View>
  )
}

export const badgeStyles = StyleSheet.create({
  base: {
    // flex: 0,
    width: 22,
    height: 22,

    borderRadius: 22 / 2,
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
  },
  badge_0: {
    right: 0,
    zIndex: 60,
  },
  badge_1: {
    right: -10,
    zIndex: 59,
  },
})
